<template>
	<div>
		<input type="text" v-model="localValue" :name="name" class="hidden" />
		<div class="flex items-center" v-if="inline">
			<!-- On: "bg-blue-600", Off: "bg-gray-200" -->
			<button
				type="button"
				dusk="accept-terms-toggle-button"
				:aria-pressed="localValue"
				class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-75 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
				:class="{
                    'translate-x-5': localValue,
                    'translate-x-0': !localValue,
				}"
				@click="toggle"
			>
				<span class="sr-only">Use setting</span>
				<!-- On: "translate-x-5", Off: "translate-x-0" -->
				<span
					aria-hidden="true"
					class="inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-75"
					:class="{
						'translate-x-5': (localValue === 1),
						'translate-x-0': (localValue === 0),
					}"
				></span>
			</button>
			<span class="ml-3">
				<span
					class="text-base md:text-sm font-medium text-gray-900"
					v-html="label"
				></span>
				<span
					class="hidden md:block text-sm leading-normal text-gray-500"
					v-if="description"
					>{{ description }}
				</span>
			</span>
		</div>

		<div class="flex items-center justify-between" v-else>
			<span class="flex-grow flex flex-col" id="toggleLabel">
				<div class="flex items-center gap-1">
					<span
						class="text-base md:text-sm font-medium text-gray-900"
						v-html="label"
					></span>
					<!-- Info Icon for Modal -->
					<svg v-if="modal" @click="toggleModal"
					      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-midgray cursor-pointer">
						<path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
					</svg>
				</div>
				<span
					class="hidden md:block text-sm leading-normal text-gray-500 md:mr-14"
					v-if="description"
					>{{ description }}
				</span>
			</span>
			<button
				type="button"
				dusk="accept-terms-toggle-button"
				aria-pressed="false"
				aria-labelledby="toggleLabel"
				class="ml-4 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full transition-colors ease-in-out duration-200 focus:outline-none "
				:class="{
					'bg-cyan': localValue,
					'bg-gray-200': !localValue,
					'opacity-25 cursor-default': disabled,
					'focus:ring-2 focus:ring-offset-2 focus:ring-cyan cursor-pointer': !disabled,
				}"
				@click="toggle"
			>
				<span class="sr-only">Use setting</span>
				<span
					aria-hidden="true"
					class="inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
					:class="{
						'translate-x-5': localValue,
						'translate-x-0': !localValue,
					}"
				></span>
			</button>
		</div>
		<div class="block md:hidden pt-3">
			<span class="text-sm leading-normal text-gray-500" v-if="description">
				{{ description }}
			</span>
		</div>

		<modal v-if="modal" ref="modal" :title="label">
			<service-information 
				v-for="item in modal" :key="item.title" 
				:title="item.title" 
				:description="item.description"
			></service-information>
		</modal>
	</div>
</template>

<script>
import Modal from './Modal.vue'
import ServiceInformation from'./ServiceInformation.vue'

export default {
	name: 'Toggle',
	components: {
		Modal,
		ServiceInformation,
	},
	computed: {
		localValue: {
			get() {
				return this.value
			},
			set(localValue) {
				this.$emit('input', localValue)
			},
		},
	},
	props: {
		value: {
			type: Boolean | Number,
			default: null,
		},
		name: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: '',
		},
		description: {
			type: String,
			default: '',
		},
		inline: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		textAlign: {
			type: String,
			default: null,
		},
		modal: {
			type: Boolean | Array,
			default: false,
		}
	},

	methods: {
		toggle() {
			if (this.disabled) {
				return false
			}
			this.localValue = !this.localValue
			this.$emit('change')
		},
		on() {
			this.localValue = true
		},
		off() {
			this.localValue = false
		},
		toggleModal() {
            this.$refs.modal.toggleModal()
        }
	},
}
</script>

<style scoped></style>
